import Vue from 'vue';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

let connection = null;
let manuallyStopped = true;

const SignalREventBus = new Vue();

const DEFAULT_EVENTS = [
  'MainList115',
  'MainList800',
  'TopList800',
  'MainListAdmission',
  'MainListDoctor',
  'MainListFollowUp',
  'NewMission800',
  'HospitalList',
  'OutOfServiceCodes',
  'WaitInHospitalList',
  'OutOfServiceHospital',
  'CodeListFollowUp',
  'HospitalMainList',
  'DispatchNotification',
  'MainDashboard115',
  'VehicleReadiness',
  'CurrentMissionsCount',
];

function createConnection({ hubUrl, getToken }) {
  connection = new HubConnectionBuilder()
    .withUrl(hubUrl, {
      withCredentials: true,
      accessTokenFactory: () => getToken?.() || '',
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: (ctx) =>
        ctx.previousRetryCount < 12000000000000 ? 1000 : null,
    })
    .configureLogging(LogLevel.None)
    .build();
}

function registerEvents(events) {
  events.forEach((event) => {
    connection.on(event, (payload) => {
      SignalREventBus.$emit(event, payload);
    });
  });
}

async function start(router) {
  // console.log('start!!');
  if (!connection || !manuallyStopped) return;

  // 🚫 Don't connect on login page
  if (router?.currentRoute?.name === 'login') return;

  manuallyStopped = false;

  try {
    await connection.start();
    // console.log('[SignalR] connected');
  } catch (err) {
    // ⛔ Stop reconnect on 401
    if (err?.statusCode === 401 || err?.message?.includes('401')) {
      // console.warn('[SignalR] stopped due to 401');
      stop();
      return;
    }

    setTimeout(() => start(router), 5000);
  }
}

function stop() {
  manuallyStopped = true;
  if (connection?.state === 'Connected') {
    connection.stop();
  }
}

function handleClose(router) {
  connection.onclose(() => {
    if (!manuallyStopped) {
      start(router);
    }
  });
}

export default {
  install(Vue, options) {
    if (!options?.hubUrl) {
      throw new Error('[SignalR Plugin] hubUrl is required');
    }

    createConnection({
      hubUrl: options.hubUrl,
      getToken: options.getToken,
    });

    registerEvents(options.events || DEFAULT_EVENTS);
    handleClose(options.router);

    Vue.prototype.$mobileSignalr = {
      start: () => start(options.router),
      stop,
      bus: SignalREventBus,
      connection,
    };
  },
};
